import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CImg,
} from "@coreui/react";

// sidebar nav config
import {
  admin_nav,
  branch_nav,
  delivery_nav,
  offline_nav,
  order_nav,
} from "./_nav";

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebar.sidebarShow);
  const role = useSelector((state) => state.auth.user.role);
  var color = "rgb(181 33 28);";

  if (role === "admin") {
    color = "#03256C";
  } else if (role === "branch") {
    color = "#0d1c2f";
  } else {
    color = "rgb(0 42 78)";
  }

  const getRoute = () => {
    if (role === "admin") {
      return admin_nav;
    } else if (role === "branch") {
      return branch_nav;
    } else if (role === "deliveryexecutive") {
      return delivery_nav;
    } else if (role === "offlineexecutive") {
      return offline_nav;
    } else if (role === "orderexecutive") {
      return order_nav;
    }
  };

  return (
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({ type: "set", sidebarShow: val })}
    >
      <CSidebarBrand
        className="d-md-down-none"
        to="/dashboard"
        style={{ backgroundColor: color }}
      >
        <CImg
          src={"./images/logo/loginlogo.png"}
          style={{ margin: "15px" }}
          width="50"
          height="50"
        />
      </CSidebarBrand>
      <CSidebarNav style={{ backgroundColor: color }}>
        <CCreateElement
          items={getRoute() || []}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer
        className="c-d-md-down-none"
        style={{ backgroundColor: color }}
      />
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
